<template>
  <AuthLayout v-if="!isAuthenticated" />
  <DefaultLayout v-else />
</template>

<script lang="ts">
import { ElNotification } from 'element-plus'
import { computed, defineComponent, provide, watch } from 'vue'
import { useStore } from 'vuex'
import { Ability, AbilityBuilder } from '@casl/ability'
import { useAbility } from '@casl/vue'
import AuthLayout from './layouts/auth-layout.vue'
import DefaultLayout from './layouts/default-layout.vue'
import { ROLE_PERMISSIONS } from 'core/constants'

export default defineComponent({
  name: 'App',
  components: {
    AuthLayout,
    DefaultLayout,
  },
  setup() {
    const store = useStore()
    const $ability = useAbility()
    const loading = computed(() => store.state.loading)
    const isAuthenticated = computed(() => {
      const user = store.getters['user/user']
      if (user) {
        updateAbility(user)
      }
      return store.getters['auth/isAuthenticated']
    })
    const initialize = () => {
      store.commit('SET_LOADING', true)
      return Promise.resolve()
    }

    watch(loading, () => {
      const elm = document.getElementById('global-loading')
      if (loading.value) {
        elm?.classList.remove('hidden')
      } else {
        elm?.classList.add('hidden')
      }
    })

    initialize()
      .then(() => store.dispatch('initialized', true))
      .finally(() => store.commit('SET_LOADING', false))

    const notify = (message: string, flag: boolean) => {
      if (flag) {
        return ElNotification({
          message,
          type: 'success',
        })
      }
      return ElNotification({ message, type: 'error' })
    }

    provide('notify', notify)

    const updateAbility = (user: UserModel) => {
      const { can, rules } = new AbilityBuilder(Ability)

      const role = ROLE_PERMISSIONS.find((r) => r.type === user.role)

      role?.permissions.forEach((p) => {
        can(p.action, p.name)
      })

      $ability.update(rules)
    }

    return {
      isAuthenticated,
    }
  },
})
</script>
